const getDateFormatted = date => `${date.getFullYear()}-${date.getDate()}-${date.getMonth() + 1}`;

export default getDateFormatted;
